export default "__VITE_ASSET__ed3cbaf3__"